import { FetchError } from "common/fetch/errors";
import { parseNumber } from "common/utils/numbers";
import { StatusCode } from "common/fetch/types";
import { useNavigate, useSearchState } from "common/router/hooks";
import errorImages from "common/constants/errorImages";

import ErrorPage from "client/common/components/errors/ErrorPage";
import FetchErrorPage from "client/common/components/errors/FetchErrorPage";
import { Paths, urls } from "client/routes";

const CheckoutErrorPage = () => {
  const [params] = useSearchState<Paths["checkout"]["error"]>({
    status: undefined,
  });
  const navigate = useNavigate();

  if (params.status) {
    return (
      <FetchErrorPage
        entityName="cart"
        error={new FetchError(parseNumber(params.status, StatusCode.InternalServerError))}
        buttonText="Try Again"
        onButtonClick={() => navigate(urls.checkout.start())}
      />
    );
  }
  return (
    <ErrorPage
      title="Something went wrong!"
      image={errorImages.Error500}
      imageAlt="Error 500"
      description="An error occurred during checkout - please try again."
      refresh={true}
      buttonText="Try again"
      buttonLink={urls.checkout.start.to()}
    />
  );
};

export default CheckoutErrorPage;
